<header class="flex header">
  <h2>
    @if (role) {
      {{ 'UserSetRoles_Title_Update' | translateWF: 'Update Role User' }}
    } @else {
      {{ 'UserSetRoles_Title_Add' | translateWF: 'Add Role User' }}
    }
  </h2>
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>
<div class="content">
  <p-card>
    <div class="col">
      <div class="form-box">
        <label for="">{{ 'UserSetRoles_Name' | translateWF: 'Name' }}</label>
        <input type="text" pInputText [formControl]="name" />
      </div>
      <div class="form-box">
        <label for="">{{ 'UserSetRoles_Description' | translateWF: 'Description' }}</label>
        <input type="text" pInputText [formControl]="description" />
      </div>
      <div class="form-box">
        <label for="roleType">{{ 'UserSetRoles_Type' | translateWF: 'Type' }}</label>
        <p-select inputId="roleType" [options]="typeOptions" optionLabel="fallback" optionValue="value" [formControl]="type" appendTo="body" styleClass="cs-fill-width">
          <ng-template #selectedItem let-option>{{ option.key | translateWF: option.fallback }}</ng-template>
          <ng-template #item let-option>{{ option.key | translateWF: option.fallback }}</ng-template>
        </p-select>
        <small>{{ 'UserSetRoles_Type_Hint' | translateWF: 'A group only offers roles of its own type.' }}</small>
      </div>
    </div>
  </p-card>
</div>
<footer>
  <p-button class="w-full" label="{{ 'UserSetRoles_Save' | translateWF: 'Save' }}" (click)="onSubmit()" />
  <p-button class="w-full" label="{{ 'UserSetRoles_Exit' | translateWF: 'Exit' }}" variant="outlined" (click)="onClose()" />
</footer>
